'use client';

import type { StateAbbreviation } from '@ria-client/supergraph/marketplace/types';
import { STATE_OPTIONS } from './constants';
import { Dropdown } from './Dropdown';
import { GeoDropdownSkeleton } from './GeoDropdownSkeleton';
import { useGeo } from './GeoProvider';

export interface GeoDropdownProps {
  initialLocation: StateAbbreviation;
}

export function GeoDropdown({ initialLocation }: GeoDropdownProps) {
  const { isReady, regionCode, setRegionCode } = useGeo();

  if (!isReady) {
    return <GeoDropdownSkeleton />;
  }

  return (
    <Dropdown
      id="geo-dropdown"
      label="Show accounts available in"
      onChange={value => {
        setRegionCode(value as StateAbbreviation);
      }}
      options={STATE_OPTIONS}
      value={regionCode ?? initialLocation}
    />
  );
}
